<template>
    <panel class="border border-secondary" :noButton="true">
        <template>
             <template slot="header">
                <h4 class="panel-title">QRCode Detail</h4>

            </template>

            <table class="table table-borderless">
                <thead>
                    <tr>
                        <th>Object Description</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody v-for="(key , index) in keys">
                    <tr>
                        <td>{{tableHeader[index]}}</td>
                        <td>{{detailObject[key]}}</td>
                    </tr>
                </tbody>
            </table>
        </template>

    </panel>
</template>

<script>
export default {
    props : ['detailObject'],
    data(){
        var keys = Object.keys(this.detailObject);

        var tzoffset = (new Date()).getTimezoneOffset() * 60000;
        this.detailObject.created_at =  new Date(new Date(this.detailObject.created_at) - tzoffset).toISOString().slice(0, 19).replace('T', ' ')

        var tableHeader = [];

        for(var i = 0 ; i < keys.length; i++){
            var text = keys[i];
        if(text === "current_loc_code") text = "location" // Dirty Trick
            text = text.split("_");

            // Dirty Trick to change 'no' to 'No.'
            for(let i = 0; i < text.length ; ++i) {
                text[i] = text[i].charAt(0).toUpperCase() + text[i].substring(1);
                if(text[i] === "No") text[1] += '.'
            }

            text = text.join(' ');
            if(text === 'Rrn') text = "RRN"; // Dirty Trick

            tableHeader.push(text);
        }

        return {
            keys : keys,
            tableHeader : tableHeader
        }
    }
}
</script>